import { Box, HStack, Image, Pressable, Text, VStack } from "native-base";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { SearchInput } from "../components/SearchInput";
import { getHelpParagraph } from "../helper/help.helper";
import React from "react";

const renderTextWithLinks = (text: string) => {
    // Regex for URLs (http://, https://, www., or domain patterns)
    // Improved to detect domains like track.a2a56.com
    // Pattern: (protocol://) | www. | domain with subdomains
    const urlRegex = /(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+|[a-zA-Z0-9][a-zA-Z0-9.-]*[a-zA-Z0-9]\.[a-zA-Z]{2,}(?:\/[^\s<>"']*)?)/gi;
    // Regex for emails
    const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi;
    
    const matches: Array<{index: number, length: number, type: 'url' | 'email', text: string, href?: string}> = [];
    let match;
    let key = 0;
    
    // Find all URLs
    urlRegex.lastIndex = 0;
    while ((match = urlRegex.exec(text)) !== null) {
        let url = match[0];
        // Remove trailing punctuation that might have been captured
        url = url.replace(/[.,;:!?]+$/, '');
        
        // Ensure URL has protocol
        const href = url.startsWith('www.') ? `https://${url}` : 
                     url.startsWith('http://') || url.startsWith('https://') ? url : 
                     `https://${url}`;
        matches.push({
            index: match.index,
            length: url.length,
            type: 'url',
            text: url,
            href: href
        });
    }
    
    // Find all emails
    emailRegex.lastIndex = 0;
    while ((match = emailRegex.exec(text)) !== null) {
        matches.push({
            index: match.index,
            length: match[0].length,
            type: 'email',
            text: match[0]
        });
    }
    
    // Sort matches by index
    matches.sort((a, b) => a.index - b.index);
    
    // Remove overlapping matches (prioritize emails over URLs)
    const filteredMatches: typeof matches = [];
    for (let i = 0; i < matches.length; i++) {
        const current = matches[i];
        let overlaps = false;
        
        for (let j = 0; j < filteredMatches.length; j++) {
            const existing = filteredMatches[j];
            if (current.index < existing.index + existing.length && 
                current.index + current.length > existing.index) {
                overlaps = true;
                // If current is email and existing is URL, replace it
                if (current.type === 'email' && existing.type === 'url') {
                    filteredMatches[j] = current;
                }
                break;
            }
        }
        
        if (!overlaps) {
            filteredMatches.push(current);
        }
    }
    
    // Build parts array
    const parts: (string | JSX.Element)[] = [];
    let lastIndex = 0;
    
    filteredMatches.forEach((match) => {
        // Add text before the match
        if (match.index > lastIndex) {
            parts.push(text.substring(lastIndex, match.index));
        }
        
        // Add the link
        if (match.type === 'email') {
            parts.push(
                <a key={key++} href={`mailto:${match.text}`} style={{ color: '#1264A3', textDecoration: 'underline', cursor: 'pointer' }}>
                    {match.text}
                </a>
            );
        } else {
            const href = match.href || match.text;
            parts.push(
                <a key={key++} href={href} target="_blank" rel="noopener noreferrer" style={{ color: '#1264A3', textDecoration: 'underline', cursor: 'pointer' }}>
                    {match.text}
                </a>
            );
        }
        
        lastIndex = match.index + match.length;
    });
    
    // Add remaining text
    if (lastIndex < text.length) {
        parts.push(text.substring(lastIndex));
    }
    
    return parts.length > 0 ? parts : [text];
};

export const HelpQuestion = () => {
    const param = useParams();
    const [title, setTitle] = useState("")
    const [text, setText] = useState<string[]>([])
    const { t, i18n } = useTranslation();
    useEffect(() => {
        // @ts-ignore
        const result = getHelpParagraph(param.id, t)
        setTitle(result.title);
        setText(result.paragraphs)
    },[param.id, t, i18n.language])
    return <Box>
        <div className="landing_container landing_gradient" style={{ zIndex: 3, height: '482px' }}>
            <Navbar upper={true} />
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '32px' }}>
                <div style={{ width: "194px", height: "194px", position: 'relative', marginLeft: '100px', marginTop: "45px" }}>
                    <Image
                        width={'194px'}
                        height={'194px'}
                        style={{ position: 'absolute' }}
                        resizeMode={'cover'}
                        source={{
                            uri: `${process.env.PUBLIC_URL}/icons/help/help_1.svg`,
                        }}
                    />
                </div>

                <Box width="40%">
                    <Text color="#ffb31c" textAlign="center" fontStyle="italic" fontWeight={800} fontFamily="Segoe UI" fontSize={window.innerWidth < 1920 ? "53px" : "60px"}>{t('hy')}</Text>
                    <Text color="#ffffff" textAlign="center" bold fontStyle="italic" fontSize={window.innerWidth < 1920 ? "43px" : "50px"} fontFamily="Segoe UI" mb="20px">{t('how_can_we_help_you')}</Text>
                    <Text color="#ffffff" textAlign="center" fontSize="20px" fontFamily="Segoe UI" mb="20px">{t('search_in_our')}</Text>
                    <SearchInput onlyArrow />
                </Box>
                <div style={{ width: "194px", height: "194px", position: 'relative', marginRight: '100px', marginTop: "45px" }}>
                    <Image
                        width={'194px'}
                        height={'194px'}
                        style={{ position: 'absolute' }}
                        resizeMode={'cover'}
                        source={{
                            uri: `${process.env.PUBLIC_URL}/icons/help/help_2.svg`,
                        }}
                    />
                </div>
            </div>
        </div>
        <VStack mx={"auto"} width="655px" mt={30} mb={30}>
            <Link to={`/help`} style={{ textDecoration: 'none', width: '100%' }}>
                <Pressable p={0} m={0}>
                    {({ isHovered }) => {
                        return (
                            <HStack width="100%">
                                <Image
                                    width={'22px'}
                                    height={'22px'}
                                    resizeMode={'cover'}
                                    source={{
                                        uri: `${process.env.PUBLIC_URL}/icons/help/arrow.svg`,
                                    }}
                                />
                                <Text textDecorationLine={ isHovered ? 'underline' : "none"} fontSize="17px" color="#1264A3" ml="10px">{t('help_center_button')}</Text>
                            </HStack>
                        )
                    }}
                </Pressable>
            </Link>
            <Text color="#293d8b" mt={30} bold fontSize={25}>{title}</Text>
        </VStack>
        <VStack maxWidth="60%" width="655px" mx={'auto'} flexWrap="wrap">
            {text.map((el, index) => (
                <Text key={index} fontSize="20px">
                    {renderTextWithLinks(el)}
                </Text>
            ))}
        </VStack>
        <Box width="100%" mt="40px" display="flex" flexDir="row" justifyContent="center" backgroundColor="#f6f6f6" pt="40px" position={window.innerWidth < 1920 ? "relative" : undefined}>
            <Footer />
        </Box>
    </Box>
}